import React from 'react'
import Layout from './layout/layout'
function Contactus() {
  return (
    <div>
      <h1>welcome to the contact page</h1>
    </div>
  )
}

export default Contactus
